import api from 'infra/config/api';

export default function updateBookCurrentPageService(data) {
    const url = '/update-book-progress.php';
    return api
        .url(url)
        .post(data)
        .json();
}